export default "__VITE_ASSET__ddf68512__"